import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";
import { path } from "d3";
import { element } from "prop-types";
const CurrentHrProbation = React.lazy(() => import ("@/pages/probation/hrProbation/hrProbationTab/CurrentHrProbation"));
const ExtendedHrProbation = React.lazy(() => import("@/pages/probation/hrProbation/hrProbationTab/ExtendedHrProbation"))
const DeemedConfirmationProbation = React.lazy(() =>import("@/pages/probation/hrProbation/hrProbationTab/DeemedConfirmationProbation"));
const ConfirmedHrProbation = React.lazy(() => import("@/pages/probation/hrProbation/hrProbationTab/ConfirmedHrProbation"));
const PendingHrProbation = React.lazy(() => import("@/pages/probation/hrProbation/hrProbationTab/PendingHrProbation"));
const HrSubmitFeedbackForm = React.lazy(() => import ("@/pages/probation/hrProbation/hrForm/HrSubmitFeedbackForm"));
const IndexTab = React.lazy(() => import ("@/pages/probation/hrProbation/indexTab"));
const IndexTabTrainee = React.lazy(() => import ("@/pages/probation/traineeProbation/indexTab"));
const Index = React.lazy(() => import ("@/pages/probation/hrProbation/index"));


const IndexHrProbation = [
    // {
    //     path: "hrProbation",
    //     element: (
    //         <SuspenseWrapper>
    //             <Index />
    //         </SuspenseWrapper>
    //     ),
    // },
    {
        path: "currentHrProbationList",
        element: (
            <SuspenseWrapper>
                <CurrentHrProbation />
            </SuspenseWrapper>
        ),
    },
    {
        path: "HrProbationList",
        element: (
            <SuspenseWrapper>
                <IndexTab />
            </SuspenseWrapper>
        ),
    },
    {
        path: "traineeHrProbationList",
        element: (
            <SuspenseWrapper>
                <IndexTabTrainee />
            </SuspenseWrapper>
        ),
    },
    {
        path: "deemedHrProbationList",
        element: (
            <SuspenseWrapper>
                <DeemedConfirmationProbation />
            </SuspenseWrapper>
        ),
    },
    {
        path: "extendedHrProbationList",
        element: (
            <SuspenseWrapper>
                <ExtendedHrProbation />
            </SuspenseWrapper>
        ),
    },
    {
        path: "confirmedHrProbationList",
        element: (
            <SuspenseWrapper>
                <ConfirmedHrProbation />
            </SuspenseWrapper>
        ),
    },
    {
        path:"hrSubmitFeedbackForm",
        element:(
            <SuspenseWrapper>
                <HrSubmitFeedbackForm />
            </SuspenseWrapper>
        ),
    },
    {
        path:"pendingHrProbation",
        element:(
            <SuspenseWrapper>
                <PendingHrProbation />
            </SuspenseWrapper>
        ),
    }

];
export default IndexHrProbation;